module.exports = __webpack_public_path__ + "img/icon_login_bg.f409cc66.png";